import {
    OFFLINE_READY,
    CHECKOUT_PROGRESS,
    CHECKIN_PROGRESS,
    CONNECTION_STATE,
} from '../actions/offline';

const offlineShape = {
    connected: true,
    ready: false,
    content: {
        // [content.id]: {
        //     totalPages: 100,
        //     localpages: 50
        // }
    },
};

export default function offlineReducer(state = offlineShape, action) {
    switch (action.type) {
        case CONNECTION_STATE:
            return {
                ...state,
                connected: action.payload,
                connectedAt: Date.now(),
            };
        case OFFLINE_READY:
            return {
                ...state,
                ready: true,
            };
        case CHECKIN_PROGRESS: {
            const { contentId, done } = action.payload;
            const {
                [String(contentId)]: tmp, // eslint-disable-line no-unused-vars
                ...content
            } = state.content;

            if (done) {
                return {
                    ...state,
                    content,
                };
            }

            return {
                ...state,
                content: {
                    ...content,
                    [contentId]: {
                        ...tmp,
                        deleting: true,
                    },
                },
            };
        }
        case CHECKOUT_PROGRESS: {
            const { contentId, done, total, error } = action.payload;

            return {
                ...state,
                content: {
                    ...state.content,
                    [contentId]: {
                        totalPages: total,
                        localPages: done,
                        error,
                    },
                },
            };
        }
    }

    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/offline.js